<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{ aLang.c_create }} tin tức</span>
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} tin tức</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} tin tức</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="8">
              <el-form-item label="Tiêu đề" prop="tieu_de">
                <el-input v-model="mData.dataForm.tieu_de" :disabled="mData.viewMode == 'detail'" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Trạng thái hiển thị" prop="hien_thi">
                <el-select v-model="mData.dataForm.hien_thi" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listHienThi" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Ngôn ngữ" prop="ngon_ngu">
                <el-select v-model="mData.dataForm.ngon_ngu" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listNgonNgu" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12" style="margin-bottom: 10px;">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="image_id">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Mô tả" prop="description">
                <!-- <CknoimgComponent
                  v-model="mData.dataForm.description"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                  @blur="handleBlur('description')"
                ></CknoimgComponent> -->
                <el-input :disabled="mData.viewMode == 'detail'" type="textarea" :rows="2"
                  v-model="mData.dataForm.description">
                </el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Nội dung" prop="content">
                <CknoimgComponent v-model="mData.dataForm.content"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'" @blur="handleBlur('content')">
                </CknoimgComponent>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Nguồn bài viết" prop="nguon_bai_viet">
                <el-select v-model="mData.dataForm.nguon_bai_viet" :disabled="mData.viewMode == 'detail'" multiple
                  filterable>
                  <el-option v-for="item in mData.dataOther.nguonTinTuc" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Từ khoá" prop="tags">
                <el-select v-model="mData.dataForm.tags" multiple filterable allow-create default-first-option
                  placeholder="Thêm tag cho bài viết" no-data-text="Nhấn Enter để thêm tag">
                  <el-option v-for="item in mData.dataDefault.tagList" :disabled="mData.viewMode == 'detail'"
                    :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Người tạo" v-if="mData.viewMode == 'detail'">
                <el-input v-model="mData.dataForm.ten_nguoi_tao" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Thời gian tạo" v-if="mData.viewMode == 'detail'">
                <el-date-picker type="datetime" v-model="mData.dataForm.thoi_diem_tao"
                  :format="aElement.datepicker.formatDatetime" :valueFormat="aElement.datepicker.valueFormat"
                  :disabled="mData.viewMode == 'detail'" :placeholder="aElement.datepicker.placeholderDatetime">
                </el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Người cập nhật" v-if="mData.viewMode == 'detail'">
                <el-input v-model="mData.dataForm.ten_nguoi_cap_nhat" disabled clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Thời gian cập nhật" v-if="mData.viewMode == 'detail'">
                <el-date-picker type="datetime" v-model="mData.dataForm.lastModificationTime"
                  :format="aElement.datepicker.formatDatetime" :valueFormat="aElement.datepicker.valueFormat"
                  :disabled="mData.viewMode == 'detail'" :placeholder="aElement.datepicker.placeholderDatetime">
                </el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('create')" v-ladda
              v-if="mData.viewMode == 'create'">{{ aLang.c_create }}</el-button>

            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda
              v-if="mData.viewMode == 'update'">{{ aLang.c_update }}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import DataService from '@/service/DataService';
import MethodService from '../../../service/MethodService';
import TinTucModel from './TinTucModel';
import TinTucApi from '../../../moduleApi/TinTucApi';
import ProfileApi from '@/moduleApi/ProfileApi';
import NguonBaiVietApi from '@/moduleApi/NguonBaiVietApi';
import ExtensionService from "../../../service/ExtensionService";
import CknoimgComponent from "../../../component/CknoimgComponent";
export default {
  components: {
    CknoimgComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "TinTuc",
        dataDefault: {
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
          tagList: []
        },
        dataOther: {
          nguonTinTuc: []
        },
        dataForm: MethodService.copyObject(TinTucModel.dataForm),
        fileUploadOption: MethodService.copyObject(
          TinTucModel.dataFormOther.fileUploadOption
        ),
        validForm: TinTucModel.validForm,
      },
    };
  },
  created() {
    this.getListNguonTinTuc();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  methods: {
    async getListNguonTinTuc() {
      let dataFilter = {
        filters: 'hien_thi=true'
      };
      dataFilter.limit = 10000;
      let nguon_tin_tucs = await NguonBaiVietApi.list(dataFilter);
      if (nguon_tin_tucs.result) {
        nguon_tin_tucs.result.forEach(nguon_tin_tuc => {
          this.mData.dataOther.nguonTinTuc.push({
            value: nguon_tin_tuc.id,
            label: nguon_tin_tuc.ten,
          })
        })
      }
    },

    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "create") {
            data.category = "News";
            await TinTucApi.create(data);
            this.fn_go();
            this.fn_resetForm();
          }
          if (type === "update") {
            data.id = this.$router.currentRoute.params.id;
            await TinTucApi.update(data);
            this.fn_go();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        TinTucModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let tin_tuc = await TinTucApi.findById(id);
      if (tin_tuc.result) {
        this.mData.dataForm = tin_tuc.result;

        if (tin_tuc.result.image_id) {
          let data = {
            id: tin_tuc.result.image_id,
            name: tin_tuc.result.image_id,
            url: ExtensionService.urlImg + tin_tuc.result.image_id
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }

        const nguoiTao = await ProfileApi.findById(
          tin_tuc.result.nguoi_tao
        );
        if (nguoiTao.result) {
          this.mData.dataForm.ten_nguoi_tao = nguoiTao.result.ho_ten.ho_ten
        }
        const nguoiCapNhat = await ProfileApi.findById(
          tin_tuc.result.lastModifierUserId
        );
        if (nguoiCapNhat.result) {
          this.mData.dataForm.ten_nguoi_cap_nhat = nguoiCapNhat.result.ho_ten.ho_ten
        }
      }
      this.$forceUpdate();
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    fn_go() {
      this.$router.go(-1);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.image_id = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField('image_id');
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "tinTuc")
        .then(res => {
          this.mData.dataForm.image_id = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField('image_id');
        })
        .catch(() => {
          this.$refs["myForm"].validateField('image_id');
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    }
  }
}
</script>
